export default {
  setWorkspaceAiIsEnabled(state, payload) {
    state.workspaceAiIsEnabled = payload;
  },
};
